module.exports = __webpack_public_path__ + "img/zero_btn.ccda48f9.png";